import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Configuration } from '../Constants/configuration';
import { StorageService } from './storage.service';
import { CocheSeguro } from '../modelos/cocheSeguro.model';

@Injectable({ providedIn: 'root' })
export class RequestServices {
    private DEFAULT_URL: string;
    private URLMASTER: string;
    private S4_KEY: string;
    private CONFIG: Configuration;
    private IS_DEBUG: boolean;
    private storageService: StorageService = new StorageService();

    constructor(private http: HttpClient) {
        this.CONFIG = new Configuration();
        this.S4_KEY = this.CONFIG.S4_KEY;
        this.DEFAULT_URL = this.CONFIG.URL;
        this.IS_DEBUG = this.CONFIG.IS_DEBUG;
        this.URLMASTER = this.CONFIG.URLMASTER;
    }

    onPayment(params: any): Observable<any>{
        let headers: HttpHeaders = new HttpHeaders();
        headers.set('Content-Type', 'application/json; charset=utf-8');
       return this.http.post<any>(`http://944329208daa.ngrok.io/aseguradoras/22/pago`, {...params}, {headers: headers});
    }

    /**REQUEST DE MARKETPLACE */
    getRequestMaster(requestGetConfig: RequestGetConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let parameters = '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + "&";
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.URLMASTER) + requestGetConfig.apiName + parameters);
    }

    getRequest(requestGetConfig: RequestGetConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let parameters = '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + "&";
        if (requestGetConfig.apiName == "QuattroAutosBuscador") {
            parameters = '?'
        }
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        if (cocheSeguro?.tkn) {
            parameters += '&tkn=' + cocheSeguro.tkn;
        }
        this.log('getRequest', (requestGetConfig.projectName ? requestGetConfig.projectName : '') + requestGetConfig.apiName + parameters);
        if (requestGetConfig.bearer) {
            const headers = new HttpHeaders()
            .set("Content-Type", "application/json; charset=utf-8;")
            .set("Authorization", "Bearer " + this.storageService.getItem("bearerTkn"));
            return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, { headers });
        }
        // tslint:disable-next-line: max-line-length
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    getRequestOperation(requestGetConfig: RequestGetConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let parameters = '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + "&";
        if (requestGetConfig.apiName == "QuattroAutosBuscador") {
            parameters = '?'
        }
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        if (cocheSeguro?.tkn) {
            parameters += '&tkn=' + cocheSeguro.tkn;
        }
        this.log('getRequest', (requestGetConfig.projectName ? requestGetConfig.projectName : '') + requestGetConfig.apiName + parameters);
        switch (window.location.hostname) {
            case "localhost":
            case "integration.copsis.com": case "develop.copsis.com":
            case 'inter-autos-qa.web.app':
            case "inter-autos-covid-qa.web.app":
            case "skynet.copsis.com": case "genesis.copsis.com":
                return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, { headers: new HttpHeaders({
                    "X-Tenant-Instance": "db-skynet",
                    "X-Tenant-Db": "quattro00084"
                }) });
                break;
            default:
                return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, { headers: new HttpHeaders({
                    'Authorization': 'Bearer ' + this.storageService.getItem("bearerTkn")
                }) });
                break;
            }
    }
    postRequestOperationAsync(requestPostConfig: RequestPostConfig) {     
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + 'd=' + cocheSeguro[this.CONFIG.PROJECT_KEY];
        switch (window.location.hostname) {
            case "localhost":
            case 'inter-autos-qa.web.app':
            case "integration.copsis.com": case "develop.copsis.com":
            case "inter-autos-covid-qa.web.app":
            case "skynet.copsis.com": case "genesis.copsis.com":
                this.http.post(url, requestPostConfig.params, { headers: new HttpHeaders({
                    "X-Tenant-Instance": "db-skynet",
                    "X-Tenant-Db": "quattro00084"
                }) }).pipe(timeout(300000)).toPromise();
                break;
            default:
                this.http.post(url, requestPostConfig.params, { headers: new HttpHeaders({
                    'Authorization': 'Bearer ' + this.storageService.getItem("bearerTkn")
                }) }).pipe(timeout(300000)).toPromise();
                break;
            }
        
    }

    getRequestPathUrl(requestGetConfig: RequestGetConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let parameters = '?' + 'b' + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + "&";
        if (requestGetConfig.apiName == "QuattroAutosBuscador") {
            parameters = '?'
        }
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        if (cocheSeguro?.tkn) {
            parameters += '&tkn=' + cocheSeguro.tkn;
        }
        this.log('getRequest', (requestGetConfig.projectName ? requestGetConfig.projectName : '') + requestGetConfig.apiName + parameters);
        // tslint:disable-next-line: max-line-length
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    postRequestRenovacion(requestPostConfig: RequestPostConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + 'd=' + '0khTLA/bXS/QvVR7C+htciDAqAagXD0NO7+Qg5czf2Yji4u/81ykb+Z0O+VXQbNl';  

        switch (window.location.hostname) {
            case "localhost":
            case "integration.copsis.com": case "develop.copsis.com":
            case "inter-autos-covid-qa.web.app":
            case 'inter-autos-qa.web.app':
            case "skynet.copsis.com": case "genesis.copsis.com":
                return this.http.post(url, requestPostConfig.params, {
                headers: new HttpHeaders({
                    "x-tenant-db":"quattro00084",
                    "x-tenant-instance":"db-skynet",
                    "content-type":"application/json",
                    "user-agent":"PostmanRuntime/7.26.8",
                    "cache-control":"no-cache",
                    "postman-token":"fd0dea2e-7a56-43f8-8b09-3719eebcb7ce",
                    "accept-encoding":"gzip, deflate, br", 
                    "connection":"keep-alive",
                    "content-length":"436"
                })
                }).pipe(timeout(300000));
                break;
            default:
                return this.http.post(url, requestPostConfig.params, {
                headers: new HttpHeaders({
                    'Content-Type': requestPostConfig.contentType + "; charset=utf-8;",
                    'Authorization': 'Bearer ' + this.storageService.getItem("bearerTkn"),
                    "content-type":"application/json",
                    "user-agent":"PostmanRuntime/7.26.8",
                    "cache-control":"no-cache",
                    "postman-token":"fd0dea2e-7a56-43f8-8b09-3719eebcb7ce",
                    "accept-encoding":"gzip, deflate, br", 
                    "connection":"keep-alive",
                    "content-length":"436"
                })
                }).pipe(timeout(300000));
                break;
            }


    }

    getRequestZurich(requestGetConfig: RequestGetConfig): Observable<any> {
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let parameters = '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + "&";
        if (requestGetConfig.apiName == "QuattroAutosBuscador") {
            parameters = '?'
        }
        parameters += 's4_key=' + this.S4_KEY + ((requestGetConfig.params) ? this.transformParams(requestGetConfig.params) : '');
        if (cocheSeguro?.tkn) {
            parameters += '&tkn=' + cocheSeguro.tkn;
        }
        this.log('getRequest', (requestGetConfig.projectName ? requestGetConfig.projectName : '') + requestGetConfig.apiName + parameters);
        if (requestGetConfig.bearer) {
            const headers = new HttpHeaders()
            .set("Content-Type", "application/json; charset=utf-8;")
            .set("Authorization", "Bearer " + this.storageService.getItem("bearerZurich"));
            return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters, { headers });
        }
        // tslint:disable-next-line: max-line-length
        return this.http.get((requestGetConfig.projectName ? requestGetConfig.projectName : this.DEFAULT_URL) + requestGetConfig.apiName + parameters);
    }

    postRequestZurich(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');
        if(requestPostConfig.contentType){
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {
                headers: new HttpHeaders({
                    'Content-Type': requestPostConfig.contentType,
                    'Authorization': 'Bearer ' + this.storageService.getItem("bearerZurich")
                })
            }).pipe(timeout(300000));
        }else{
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            }).pipe(timeout(300000));
        }
    }
    postRequest(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON[0].tkn = cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON.tkn = cocheSeguro.tkn;
            }
        }
        if(requestPostConfig.contentType){
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {
                headers: new HttpHeaders({
                    'Content-Type': requestPostConfig.contentType + "; charset=utf-8;",
                    'Authorization': 'Bearer ' + this.storageService.getItem("bearerTkn")
                })
            }).pipe(timeout(300000));
        }else{
            let headers = new HttpHeaders();
            headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8;');
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {headers}).pipe(timeout(300000));
        }
    }

    postRequestCotizar(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON[0].tkn = cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON.tkn = cocheSeguro.tkn;
            }
            return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'x-api-key': 'LFMQemrMhC_0K836fLBJNA-nNQo28QLn2N2J-EPBX092m1dW-kekMPylpJgXD7K4XgShHsKvAgJ2GCRBFomon9VLW9h2csnSBVkYgClca6my_gApDMjeMv_MSyC5D-fsF2p2KSewpynAXYiO7ebefIFxROuPahiwH8GLiPRsanagPLTlHG4rKvRz1rMWQoet'
                })
            }).pipe(timeout(300000));
        }
    }

    postRequestAsync(requestPostConfig: RequestPostConfig) {        
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")){
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON[0].tkn = cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON.tkn = cocheSeguro.tkn;
            }
        }

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8;');
        this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), { headers: headers }).pipe(timeout(300000)).toPromise();
    }

    postRequestAES(requestPostConfig: RequestPostConfig): Observable<any> {        
        // tslint:disable-next-line: max-line-length
        let cocheSeguro:CocheSeguro = new CocheSeguro();
        if(this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        
        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');        
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON[0].tkn = cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON.tkn = cocheSeguro.tkn;
            }
        }

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json; charset=utf-8;');

        return this.http.post(url, requestPostConfig.dataJSON, { headers }).pipe(timeout(300000));
    }


    public uploadFileAdjuntos(url, apiName: string, formData: FormData) : Observable<any> {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json; charset=utf-8;');
        return this.http.post(url + apiName, formData);
    }

    obtenerToken() {
        const userAndPass = "Qn4ttR0Crm4dm1n:qu4ttR0$1$";
        const headers = new HttpHeaders()
        .set("Content-Type", "application/json; charset=utf-8;")
        .set('Authorization', btoa(userAndPass));
        return this.http.get(new Configuration().APIGATEWAY + 'poliza/publics/ObtieneToken', { headers }).pipe(timeout(300000));
    }

    private transformParams(params: any): string {
        let paramString = '';

        if (Array.isArray(params)) {
            for (let param of params) {
                paramString += this.readJSONObject(param);
            }
        } else if (params !== undefined && typeof params === 'object') {
            paramString = this.readJSONObject(params);
        } else {
            this.log('msg', 'dato no definido');
        }

        return paramString;
    }

    private readJSONObject(obj: any): string {
        // tslint:disable-next-line: variable-name
        const _keys = Object.keys(obj);
        let data: string = '';
        for (let _key of _keys) {
            data += '&' + _key + '=' + obj[_key];
        }

        return data;
    }

    private log(evento: string, message?: any) {
        if (this.IS_DEBUG) {
            if (message) {
                console.log(evento, message);
            } else {
                console.log(evento);
            }
        }
    }

    postRequestJson(requestPostConfig: RequestPostConfig): Observable<any> {
        // tslint:disable-next-line: max-line-length
        let cocheSeguro:CocheSeguro = new CocheSeguro();        
        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }

        let url = (requestPostConfig.projectName ? requestPostConfig.projectName : this.DEFAULT_URL) + requestPostConfig.apiName + '?' + this.CONFIG.PROJECT_KEY + '=' + cocheSeguro[this.CONFIG.PROJECT_KEY] + '&s4_key=' + this.S4_KEY + ((requestPostConfig.params) ? this.transformParams(requestPostConfig.params) : '');
        if (requestPostConfig.dataJSON instanceof Array) {
            requestPostConfig.dataJSON[0][this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON[0].s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON[0].tkn = cocheSeguro.tkn;
            }
        } else {
            requestPostConfig.dataJSON[this.CONFIG.PROJECT_KEY] = cocheSeguro[this.CONFIG.PROJECT_KEY];
            requestPostConfig.dataJSON.s4_key = this.S4_KEY;
            if (cocheSeguro?.tkn) {
                requestPostConfig.dataJSON.tkn = cocheSeguro.tkn;
            }
        }

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json; charset=utf-8;');
        return this.http.post(url, JSON.stringify(requestPostConfig.dataJSON), { headers }).pipe(timeout(300000));
    }

}

export class RequestGetConfig {
    /**URL del proyecto API */
    projectName?: string;
    /**Endpoint */
    apiName: string;
    /**parametros para el api en formato JSON */
    params?: any;
    bearer?: boolean
}

export class RequestPostConfig {
    /**URL del proyecto API */
    projectName?: string;
    /**Endpoint */
    apiName: string;
    /**parametros para el api en formato JSON */
    dataJSON?: any;    
    params?: any;
    formData?: FormData;
    contentType?: string;
}




